import { createContext } from 'react';

export const TypesContext = createContext([]);
